import { render, staticRenderFns } from "./MainConstructionItem.vue?vue&type=template&id=53d00fd2&"
import script from "./MainConstructionItem.vue?vue&type=script&lang=js&"
export * from "./MainConstructionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports